import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState, useRef } from "react";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import { toast } from "react-toastify";
import { BarLoader } from "react-spinners";

function CvAdminmilestone(props) {
  const {
    projectname,
    projectid,
    setSelectedProject,
    ownerlog,
    Notsigned,
    setInspectorModal,
    setSelectedMilestone,
    setSelectedMilestoneNumber,
    getInspectorDetails,
    projectLoaderMsg,
    viewReports,
  } = props;
  const [CMilestoneListTable, setCMilestoneListTable] = useState([]);
  const [loader, setLoader] = useState(false);
  const focusDivRef = useRef(null);
  const [finalPaymnet, setFinalPayment] = useState({
    additional: null,
    balance: null,
    previous_milestone_balance_amount: null,
    reminder_message: "",
  });

  useEffect(() => {
    var temp = [...props?.milestoneListdata];
    setCMilestoneListTable([...temp]);
  }, [props]);

  const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
    const [name, value] = cookie.split("=");
    acc[name] = decodeURIComponent(value);
    return acc;
  }, {});
  const headers = {
    "X-CSRFToken": cookies.csrftoken,
  };

  const handleStatusChange = async (e, row) => {
    const newStatus = e.target.value;
    if (newStatus === "Inspection Accepted") {
      return;
    }
    if (newStatus === "In Progress") {
      // return;

      const data = {
        project_id: row?.project,
        milestone_id: row?.id,
      };
      try {
        const response = await axios.post(
          "/cvault/milestone-re-inprogress/",
          data,
          { headers: headers }
        );
        setCMilestoneListTable([]);
        if (focusDivRef.current) {
          focusDivRef.current.focus();
        }
        setLoader(false);
        props.handleMilestoneModal(row?.project);
      } catch (error) {}
    }

    const payload = {
      project_id: row?.project,
    };

    if (newStatus === "Awaiting Payment") {
      payload.milestone_ids = [row?.id];
    } else {
      payload.milestone_id = row?.id;
    }

    if (newStatus === "Project Initiated" && finalPaymnet?.additional) {
      payload.increased_amount = finalPaymnet?.additional;
    }

    const api =
      newStatus === "Awaiting Payment"
        ? "/cvault/awaiting-payment/"
        : newStatus === "Contractor Payment Initiate" ||
          newStatus === "Contractor Payment Awaiting"
        ? "/cvault/initiate-contractor-payment/"
        : "/cvault/milestone-initiated/";

    setLoader(true);
    try {
      const finalPaymentData = await getFinalPayment(row);

      if (newStatus === "Project Initiated" && finalPaymentData?.additional) {
        payload.increased_amount = finalPaymentData.additional;
      }

      let response = await axios.post(api, payload, { headers: headers });
      setCMilestoneListTable([]);
      if (focusDivRef.current) {
        focusDivRef.current.focus();
      }
      setLoader(false);
      props.handleMilestoneModal(row?.project);
      // toast.success("Status updated successfully");
      if (newStatus === "Awaiting Payment") {
        // toast.success(
        //   `Payment request sent to the owner for Milestone (${row?.milestone_number || 1})`
        // );
      } else if (
        newStatus === "Contractor Payment Initiate" ||
        newStatus === "Contractor Payment Awaiting"
      ) {
        toast.success(
          `Contractor payment has been initiated for Milestone (${
            row?.milestone_number || 1
          }).`
        );
      } else {
        toast.success(
          `Milestone (${row?.milestone_number || 1}) successfully initiated`
        );
      }
    } catch (error) {
      console.log(error);
      setLoader(false);
    }

    var temp = [...CMilestoneListTable];
    temp?.map((ele) => {
      if (ele.id == row?.id) {
        ele.status = newStatus;
      }
    });
    console.log(temp);
    setCMilestoneListTable(temp);

    // if (newStatus === "Inspection Request") {
    //   const data = {
    //     milestone_id: id,
    //     status: newStatus,
    //   };
    //   setLoader(true);
    //   try {
    //     let response = await axios.post(
    //       "/cvault/milestone-status-upgrade/",
    //       data,
    //       { headers: headers }
    //     );
    //     setCMilestoneListTable([]);
    //     if (focusDivRef.current) {
    //       focusDivRef.current.focus();
    //     }
    //     setLoader(false);
    //     props.handleMilestoneModal(projectid);
    //     toast.success("Inspection Request sent to ClearVault Trustee");
    //   } catch (error) {
    //     console.log(error);
    //     setLoader(false);
    //   }

    //   var temp = [...CMilestoneListTable];
    //   temp?.map((ele) => {
    //     if (ele.id == id) {
    //       ele.status = newStatus;
    //     }
    //   });
    //   console.log(temp);
    //   setCMilestoneListTable(temp);
    // } else {
    //   const data = {
    //     milestone_id: id,
    //     status: newStatus,
    //   };
    //   setLoader(true);
    //   try {
    //     let response = await axios.post(
    //       "/cvault/milestone-status-upgrade/",
    //       data,
    //       { headers: headers }
    //     );
    //     setCMilestoneListTable([]);
    //     if (focusDivRef.current) {
    //       focusDivRef.current.focus();
    //     }
    //     setLoader(false);
    //     props.handleMilestoneModal(projectid);
    //     toast.success("Status updated successfully");
    //   } catch (error) {
    //     console.log(error);
    //     setLoader(false);
    //   }

    //   var temp = [...CMilestoneListTable];
    //   temp?.map((ele) => {
    //     if (ele.id == id) {
    //       ele.status = newStatus;
    //     }
    //   });
    //   console.log(temp);
    //   setCMilestoneListTable(temp);
    // }
  };

  const getFinalPayment = async (row) => {
    try {
      const response = await axios.get(
        `/cvault/milestone-accept-pay-details/?project_id=${row?.project}&milestone_id=${row?.id}`
      );

      if (response.data.result) {
        const paymentData = {
          balance: response.data?.balance,
          additional: response.data?.additional,
          reminder_message: response.data?.reminder_message,
          previous_milestone_balance_amount:
            response.data?.previous_milestone_balance_amount,
        };

        setFinalPayment(paymentData);
        // return paymentData;
      } else {
        const emptyData = {
          additional: null,
          balance: null,
          reminder_message: "",
          previous_milestone_balance_amount: "",
        };

        setFinalPayment(emptyData);
        // return emptyData;
      }
    } catch (error) {
      console.error("Error fetching final payment:", error);
      const errorData = {
        additional: null,
        balance: null,
        reminder_message: "",
        previous_milestone_balance_amount: null,
      };
      setFinalPayment(errorData);
      // return errorData;
    }
  };

  useEffect(() => {}, [CMilestoneListTable]);

  const columns = [
    {
      field: "milestone",
      headerName: "Milestone",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => (
        <div>
          {params.row?.milestone_number
            ? `${params.row.milestone_number}. ${params.row.milestone || ""}`
            : params.row.milestone || ""}
        </div>
      ),
    },
    {
      field: "milestone_description",
      headerName: "Description",
      flex: 2,
      minWidth: 200,
      renderCell: (params) => (
        <div className="MuiDataGrid-cellContent ">
          {params?.row?.milestone_description}
        </div>
      ),
    },
    {
      field: "milestone_amount",
      headerName: "Amount",
      flex: 1,
      minWidth: 100,
      headerAlign: "center", // Center align header
      renderCell: (params) => (
        <div className="MuiDataGrid-cellContent w-100 d-flex justify-content-center align-items-center ">
          {params?.row?.milestone_amount}
        </div>
      ),
    },
    {
      field: "status",
      headerName: "Milestone Status",
      flex: 1.5,
      minWidth: 200,
      headerAlign: "center", // Center align header
      renderCell: (params) => {
        return (
          <div className="w-100 d-flex justify-content-center align-items-center">
            {params?.row?.status === "Payment Initiated" ||
            params?.row?.status === "Awaiting Payment" ? (
              <select
                className="select-form-control form-control"
                value={params?.row?.status}
                style={{ width: "max-content", fontSize: "14px", width: "60%" }}
                onChange={(e) => {
                  handleStatusChange(e, params?.row);
                }}
                disabled={loader}
                onClick={() => {
                  getFinalPayment(params?.row);
                }}
              >
                {/* <option value="Inspection Request">Inspection Request</option>
                  <option value="Inspection Completed">Inspection Completed</option> */}
                {params?.row?.status === "Payment Initiated" && (
                  <option value="Payment Initiated" disabled>
                    Payment Initiated
                  </option>
                )}
                <option
                  value="Awaiting Payment"
                  disabled={params?.row?.status === "Awaiting Payment"}
                >
                  Awaiting Payment
                </option>
                <option value="Project Initiated">Initiate Milestone</option>
                {/* {options.map((option) => (
                  <option value={option} key={option} disabled={params?.row?.status==='Awaiting Payment'}>
                    {option === "Project Initiated" ? "Initiate Project" : option}
                  </option>
                ))} */}
              </select>
            ) : params?.row?.status === "Inspection Accepted" ? (
              //  ||
              //   params?.row?.status === "Contractor Payment Awaiting"
              <>
                <select
                  className="select-form-control form-control"
                  style={{
                    width: "max-content",
                    fontSize: "14px",
                    width: "60%",
                  }}
                  value={params?.row?.status}
                  onChange={(e) => {
                    if (params?.row) {
                      handleStatusChange(e, params.row);
                    }
                  }}
                  disabled={loader}
                >
                  <option value="Inspection Accepted">
                    Inspection Accepted
                  </option>
                  <option value="Contractor Payment Initiate">
                    Initiate Contractor Payment
                  </option>
                </select>
              </>
            ) : params?.row?.status === "Contractor Payment Awaiting" ? (
              "Contractor Review"
            ) : params?.row?.status === "Hold" ? (
              <>
                <select
                  className="select-form-control form-control"
                  style={{
                    width: "max-content",
                    fontSize: "14px",
                    width: "60%",
                  }}
                  value={params?.row?.status}
                  onChange={(e) => {
                    if (params?.row) {
                      handleStatusChange(e, params.row);
                    }
                  }}
                  disabled={loader}
                >
                  <option value="Hold" disabled>
                    On Hold
                  </option>
                  <option value="In Progress">In Progress</option>
                  {/* <option value="Contractor Payment Initiate">
                    Contractor Payment Initiate
                  </option> */}
                </select>
              </>
            ) : (
              <div>
                {
                  // params?.row?.status === "In Progress" ||
                  // params?.row?.status === "Completed"
                  //   ? params?.row?.status
                  //   :
                  params?.row?.status === "CR Phase"
                    ? "Owner/Contractor Review"
                    : params?.row?.status === "Awaiting Payment"
                    ? "Not Started"
                    : params?.row?.status === "Completed"
                    ? "Closed"
                    : params?.row?.status === "Initial Payment"
                    ? "Not Started"
                    : params?.row?.status === "Inspection Assigned"
                    ? "Inspector Assigned"
                    : params?.row?.status
                }
              </div>
            )}
          </div>
        );

        // return isEditable ? (
        //   <select
        //     className="select-form-control form-control"
        //     value={params?.row?.status}
        //     style={{ width: "70%" }}
        //     onChange={(e) => {
        //       handleStatusChange(e, params?.row);
        //     }}
        //   >
        //     {/* <option value="Inspection Request">Inspection Request</option>
        //       <option value="Inspection Completed">Inspection Completed</option> */}
        //     <option value="Payment Initiated" disabled>
        //       Payment Initiated
        //     </option>
        //     <option value="Awaiting Payment">Awaiting Payment</option>
        //     <option value="Project Initiated">Initiate Project</option>
        //     {/* {options.map((option) => (
        //       <option value={option} key={option} disabled={params?.row?.status==='Awaiting Payment'}>
        //         {option === "Project Initiated" ? "Initiate Project" : option}
        //       </option>
        //     ))} */}
        //   </select>
        // ) : (
        //   <div>
        //     {params?.row?.status === "In Progress" ||
        //     params?.row?.status === "Completed"
        //       ? params?.row?.status
        //       : params?.row?.status}
        //   </div>
        // );
      },
    },
    {
      field: "View Details",
      headerName: "View Details",
      flex: 1,
      headerAlign: "center",
      minWidth: 150,
      renderCell: (params) => (
        <div className=" w-100 d-flex justify-content-center align-items-center">
          <button
            className="btn detail-btn"
            style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
            onClick={() => {
              setSelectedMilestoneNumber(params?.row?.milestone_number);
              viewReports(params?.row?.id);
            }}
          >
            Show
          </button>
        </div>
      ),
    },
    {
      field: "report",
      headerName: "Inspector",
      flex: 1,
      minWidth: 150,
      headerAlign: "center", // Center align header
      renderCell: (params) =>
        params?.row?.status === "Inspection Request" ||
        params?.row?.status === "Inspection Initiated" ||
        params?.row?.status === "Inspection Assigned" ||
        params?.row?.status === "Hold" ? (
          <div className="w-100 d-flex justify-content-center align-items-center">
            <button
              className="btn detail-btn "
              onClick={() => {
                setSelectedMilestone(params?.row?.id);
                setSelectedMilestoneNumber(params?.row?.milestone_number);
                getInspectorDetails(params?.row?.id);
              }}
              disabled={params?.row?.status === "Inspection Initiated"}
              style={{ boxShadow: "0px 0px 0.5px 0.5px lightgray" }}
            >
              {params?.row?.status === "Inspection Request"
                ? params?.row?.inspection_details?.length > 0
                  ? "Re-Assign"
                  : "Assign Now"
                : params?.row?.status === "Inspection Initiated"
                ? "Assigned"
                : params?.row?.status === "Inspection Assigned" ||
                  params?.row?.status === "Hold"
                ? "Re-Assign"
                : params?.row?.status}

              {/* Assign Now */}
            </button>
          </div>
        ) : (
          <div className="w-100 d-flex justify-content-center align-items-center">
            -
          </div>
        ),
    },
  ];
  const headerClassName = "custom-header";

  const renderHeader = (params) => {
    return <div className={headerClassName}>{params.colDef.headerName}</div>;
  };

  return (
    <div ref={focusDivRef} tabIndex={-1}>
      <div className={`app-container ${loader ? "loader-container" : ""}`}>
        {loader && (
          <div className="loader-overlay">
            {" "}
            <BarLoader
              color="#F5AE41"
              width={400}
              height={10}
              className="loader"
              loading={loader}
            />
          </div>
        )}
      </div>
      <div className="d-flex justify-content-between mx-1 mb-3">
        <div className="d-flex align-items-center">
          <h4 className="fw-bold">{projectname} - Milestone List</h4>
        </div>
        <div className="d-flex align-items-center">
          <div>
            <button
              className="btn detail-btn cursor me-3"
              onClick={() => {
                setSelectedProject("");
                setSelectedMilestone(null);
                setSelectedMilestoneNumber(null);
              }}
            >
              Close
            </button>
          </div>
        </div>
      </div>

      {/* {CMilestoneListTable.length ? ( */}
      <DataGrid
        rows={CMilestoneListTable}
        columns={columns.map((column) => ({
          ...column,
          headerClassName,
          renderHeader,
        }))}
        getRowId={(row) => row.id || row.index}
        autoHeight
        initialState={{
          pagination: {
            paginationModel: { pageSize: 5, page: 0 },
          },
        }}
        pageSizeOptions={[10, 25, 50]}
        hideFooterSelectedRowCount
        localeText={{ noRowsLabel: projectLoaderMsg }}
      />
    </div>
  );
}

export default CvAdminmilestone;
